import React, { useState } from 'react'
import styled from 'styled-components'
import { useSettingsCancellationNotice } from '@/v2/hooks/settings/useSettingsCancellationNotice'
import { CardGrid, Card, CardTitle } from '@/v2/components/settings/shared'
import CancellationNoticeModal from './CancellationNoticeModal'

const Heading = styled.div`
  margin-top: 2rem;
  margin-bottom: 1rem;

  h3 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 500;
    color: #111827;
  }

  p {
    margin: 0.25rem 0 0;
    font-size: 0.875rem;
    color: #6b7280;
  }
`

const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;

  svg {
    width: 1rem;
    height: 1rem;
    color: ${({ $active }) => ($active ? '#10b981' : '#dc2626')};
  }
`

const CHECK =
  'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
const CROSS =
  'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'

const deliveryOf = ({ bySms, byEmail }) =>
  bySms && byEmail
    ? 'By Email & SMS'
    : byEmail
    ? 'By Email'
    : bySms
    ? 'By SMS'
    : 'Inactive'

const CancellationNoticeSection = () => {
  const { notice } = useSettingsCancellationNotice()
  const [isOpen, setIsOpen] = useState(false)

  if (!notice) return null

  const active = notice.bySms || notice.byEmail

  return (
    <>
      <Heading>
        <h3>Cancellation notice</h3>
        <p>
          Sent when staff cancel an appointment from Unconfirmed appointments.
        </p>
      </Heading>

      <CardGrid $minWidth="320px">
        <Card onClick={() => setIsOpen(true)}>
          <CardTitle $mb="0.75rem">When staff cancel an appointment</CardTitle>
          <Line $active={active}>
            <svg fill="currentColor" viewBox="0 0 24 24">
              <path d={active ? CHECK : CROSS} />
            </svg>
            {deliveryOf(notice)}
          </Line>
          <Line $active>
            <svg fill="currentColor" viewBox="0 0 24 24">
              <path d={CHECK} />
            </svg>
            Explains why and links to book again
          </Line>
        </Card>
      </CardGrid>

      <CancellationNoticeModal
        isOpen={isOpen}
        notice={notice}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}

export default CancellationNoticeSection
